import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { JobNumberComponent } from './job-number.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    declarations: [
        JobNumberComponent
    ],
    entryComponents: [
        JobNumberComponent
    ],
    exports: [
        JobNumberComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule
    ],
})
export class JobNumberModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            JobNumberComponent
        ]);
    }
}
